import React from 'react';
import { NavLink } from 'react-router-dom';
import { TopMenuStyle } from './Style';

import {
    ProfileOutlined,
    CalendarOutlined,
    CheckSquareOutlined,
    SettingOutlined,
    TeamOutlined,
    IdcardOutlined,
    ProjectOutlined,
    AppstoreOutlined,
    FileTextOutlined,
    FormOutlined,
    MailOutlined,
    GiftOutlined
} from '@ant-design/icons';

function TeamLeadTopMenu() {
    const path = '/teamlead';
    const iconStyle = { marginRight: -5, fontSize: 16 };

    return (
        <TopMenuStyle>
            <div className="ninjadash-top-menu">
                <ul>
                    <li>
                        <NavLink to={`${path}/mytasks`}>
                            <CheckSquareOutlined style={iconStyle} />Tasks
                        </NavLink>
                    </li>

                    <li>
                        <NavLink to={`${path}/employeeDailywork`}>
                            <FormOutlined style={iconStyle} />Daily Updates
                        </NavLink>
                    </li>

                    <li>
                        <NavLink to={`${path}/todo`}>
                            <CheckSquareOutlined style={iconStyle} />To Do
                        </NavLink>
                    </li>

                    <li>
                        <NavLink to={`${path}/leavecalender`}>
                            <CalendarOutlined style={iconStyle} />Calendar
                        </NavLink>
                    </li>

                    <li>
                        <NavLink to={`${path}/leaverequestmanage`}>
                            <MailOutlined style={iconStyle} />Leave Requests
                        </NavLink>
                    </li>

                    <li className="has-subMenu">
                        <NavLink to="#">
                            <SettingOutlined style={iconStyle} />Manage
                        </NavLink>

                        <ul className="subMenu">
                            <li>
                                <NavLink to={`${path}/leave`}>
                                    <GiftOutlined style={iconStyle} />Leave
                                </NavLink>
                            </li>

                            <li>
                                <NavLink to={`${path}/requirements`}>
                                    <FileTextOutlined style={iconStyle} />Requirements
                                </NavLink>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </TopMenuStyle>
    );
}

export default TeamLeadTopMenu;

